import React, { useState } from 'react'
import { Container, Row, Col, Button } from 'reactstrap'
import './Footer.scss'
import contactFormPhoto from '../../assets/images/contact-form-photo.png'
import mobilePhone from '../../shared/icons/mobile-phone.svg'
import emailEnveloper from '../../shared/icons/email-envelope.svg'
import sendIcon from '../../shared/icons/send-icon.svg'
import emailEnveloperWhite from '../../shared/icons/email-envelope-white.svg'
import emailEnveloperGrey from '../../shared/icons/email-envelope-grey.svg'
import helpGuide from '../../shared/icons/help-guide-icon.svg'
import helpGuideWhite from '../../shared/icons/help-guide-icon-white.svg'
import DealmedCheckbox from '../../shared/components/DealmedCheckbox'
import { DealmedTextInput, DealmedTextArea } from '../../shared/components/DealmedTextInput'
import FAQAccordion from '../../shared/components/DealmedAccordion'
import { useGate } from 'statsig-react'

const FooterTop = ({ footerData }) => {
  const [message, setMessage] = useState('')
  const [subject, setSubject] = useState('')
  // const [isTermsChecked, setIsTermsChecked] = useState(false)
  const [openFormSection, setOpenFormSection] = useState('contact')
  const {
    contactEmail,
    contactNumber,
    footerTopSlogan,
    footerTopSubmitButtonText,
    footerTopText,
    footerTopTitle,
  } = footerData
  const faqCategories = ['general', 'transactions', 'payments', 'returns']
  const faqs = [
    {
      cat: 'transactions',
      q: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?',
      a: (
        <>
          <p>This is the collapsible content. It can be any element or React component you like.</p>
          <p>It can even be another Collapsible component. Check out the next section!</p>
        </>
      ),
    },
    {
      cat: 'general',
      q: 'Sit ultrices lacus vivamus urna?',
      a: (
        <>
          <p>This is the collapsible content. It can be any element or React component you like.</p>
          <p>It can even be another Collapsible component. Check out the next section!</p>
        </>
      ),
    },
    {
      cat: 'payments',
      q: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?',
      a: (
        <>
          <p>This is the collapsible content. It can be any element or React component you like.</p>
          <p>It can even be another Collapsible component. Check out the next section!</p>
        </>
      ),
    },
    {
      cat: 'returns',
      q: 'Aliquet et nec scelerisque nibh eu vitae urna?',
      a: (
        <>
          <p>This is the collapsible content. It can be any element or React component you like.</p>
          <p>It can even be another Collapsible component. Check out the next section!</p>
        </>
      ),
    },
    {
      cat: 'returns',
      q: 'poiuytrew lkjhgfds',
      a: (
        <>
          <p>This is the collapsible content. It can be any element or React component you like.</p>
          <p>It can even be another Collapsible component. Check out the next section!</p>
        </>
      ),
    },
    {
      cat: 'general',
      q: 'asdfghjkqwerty qwertyu',
      a: (
        <>
          <p>This is the collapsible content. It can be any element or React component you like.</p>
          <p>It can even be another Collapsible component. Check out the next section!</p>
        </>
      ),
    },
    {
      q: 'asdfghjkdsg dfg df gerty qwertyu',
      a: (
        <>
          <p>This is the collapsible content. It can be any element or React component you like.</p>
          <p>It can even be another Collapsible component. Check out the next section!</p>
        </>
      ),
    },
    {
      cat: 'transactions',
      q: 'asdad, dfg dfsh dfshds qwertyu',
      a: (
        <>
          <p>This is the collapsible content. It can be any element or React component you like.</p>
          <p>It can even be another Collapsible component. Check out the next section!</p>
        </>
      ),
    },
  ]
  // import { useGate } from 'statsig-react';

  //   const testGate =  useGate("test_gate").value;
  //   {testGate && <div id="statsig-test">Test</div>}
  return (
    <Container fluid>
      <Row className="footerTop">
        <div className="contact-form">
          <div className="flare" />
          <img
            src={contactFormPhoto}
            alt="contact us"
            className="contact-form-photo"
            loading="lazy"
          />
          <Row>
            <Col className="half">
              <sup>{footerTopTitle}</sup>
              <h2>{footerTopSlogan}</h2>
              <p className="description">{footerTopText}</p>
              <div className="contact-data-list">
                <p className="contact-with-icon phone">
                  {' '}
                  <img src={mobilePhone} alt="phone-icon" loading="lazy" />
                  {contactNumber}
                </p>
                <p className="contact-with-icon mail">
                  <img src={emailEnveloper} alt="email-icon" loading="lazy" />
                  <a href="mailto:support@dealmed.com">{contactEmail}</a>
                </p>
                {/* <button
                  className="contact-with-icon help-guide"
                  onClick={() => setOpenFormSection('help')}
                >
                  <img src={helpGuide} alt="help-icon" loading="lazy"/>
                  Help Guide
                </button> */}
              </div>
            </Col>
            <Col className="right-column half">
              <div className="upper-buttons">
                <button
                  className={`contact ${openFormSection === 'contact' ? 'selected' : ''}`}
                  onClick={() => setOpenFormSection('contact')}
                >
                  <img
                    src={openFormSection === 'contact' ? emailEnveloperWhite : emailEnveloperGrey}
                    alt="send-email"
                    loading="lazy"
                  />
                  <span>Contact Form</span>
                </button>
                {/* <button
                  className={`help ${
                    openFormSection === 'help' ? 'selected' : ''
                  }`}
                  onClick={() => setOpenFormSection('help')}
                >
                  <img
                    src={
                      openFormSection === 'contact' ? helpGuide : helpGuideWhite
                    }
                    alt="help-guide"
                  />
                  <span>Help Guide</span>
                </button> */}
              </div>
              {openFormSection === 'contact' && (
                <div className="contact-form-fields">
                  <DealmedTextInput
                    type="text"
                    value={subject}
                    onChange={e => setSubject(e.target.value)}
                    placeholder="Subject"
                  ></DealmedTextInput>
                  <DealmedTextArea
                    type="text"
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                    placeholder="Write your message"
                    rows={4}
                  ></DealmedTextArea>
                  <a
                    className="send-button-url"
                    style={{ width: '100%' }}
                    href={`mailto:feedback@dealmed.com?subject=${subject}&body=${message}`}
                  >
                    <Button className="button new-layout">
                      {footerTopSubmitButtonText}
                      {/* <img src={sendIcon} alt="send icon" /> */}
                      <img src={emailEnveloperWhite} alt="send icon" loading="lazy" />
                    </Button>
                  </a>
                  {/* <DealmedCheckbox
                    className="new-layout"
                    id="aaa"
                    name="aaa"
                    isChecked={isTermsChecked}
                    onCheck={() => setIsTermsChecked(true)}
                    onUnCheck={() => setIsTermsChecked(false)}
                    newLayout
                    text={
                      <>
                        I agree to Dealmed of{' '}
                        <a href="termsconditions/privacy" target="_blank">
                          Terms of Services
                        </a>
                        .
                      </>
                    }
                  /> */}
                </div>
              )}
              {openFormSection === 'help' && (
                <FAQAccordion faqs={faqs} categories={faqCategories} />
              )}
            </Col>
          </Row>
        </div>
      </Row>
      {/* {testGate && <div id="statsig-test">Test</div>} */}
    </Container>
  )
}

export default FooterTop
